// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../../../google/protobuf/Timestamp";
import { name2num, num2name, } from "./(TimerConfig)/ColorType";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../runtime/json/scalar";
import { WireType, } from "../../../../../runtime/wire/index";
import { default as serialize, } from "../../../../../runtime/wire/serialize";
import { default as Long, } from "../../../../../runtime/Long";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        timerStart: undefined,
        colorType: "COLOR_TYPE_UNSPECIFIED",
        timeOverMessage: "",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.timerStart !== undefined)
        result.timerStart = encodeJson_1(value.timerStart);
    if (value.colorType !== undefined)
        result.colorType = tsValueToJsonValueFns.enum(value.colorType);
    if (value.timeOverMessage !== undefined)
        result.timeOverMessage = tsValueToJsonValueFns.string(value.timeOverMessage);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.timerStart !== undefined)
        result.timerStart = decodeJson_1(value.timerStart);
    if (value.colorType !== undefined)
        result.colorType = jsonValueToTsValueFns.enum(value.colorType);
    if (value.timeOverMessage !== undefined)
        result.timeOverMessage = jsonValueToTsValueFns.string(value.timeOverMessage);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.timerStart !== undefined) {
        const tsValue = value.timerStart;
        result.push([1, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
    }
    if (value.colorType !== undefined) {
        const tsValue = value.colorType;
        result.push([2, { type: WireType.Varint, value: new Long(name2num[tsValue]) }]);
    }
    if (value.timeOverMessage !== undefined) {
        const tsValue = value.timeOverMessage;
        result.push([3, tsValueToWireValueFns.string(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined;
        if (value === undefined)
            break field;
        result.timerStart = value;
    }
    field: {
        const wireValue = wireFields.get(2);
        if (wireValue === undefined)
            break field;
        const value = wireValue.type === WireType.Varint ? num2name[wireValue.value[0]] : undefined;
        if (value === undefined)
            break field;
        result.colorType = value;
    }
    field: {
        const wireValue = wireFields.get(3);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.string(wireValue);
        if (value === undefined)
            break field;
        result.timeOverMessage = value;
    }
    return result;
}
